import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const addTaskService = async (taskData: any) =>
  handleApiCall(() => ApiService.post(apiRoutes.task, taskData));

export const getTaskService = async (query: any) =>
  handleApiCall(() => ApiService.get(apiRoutes.task.replace(":query", query)));

export const getTaskByIdService = async (id: string) =>
  handleApiCall(() => ApiService.get(apiRoutes.taskById.replace(":id", id)));

export const deleteTaskByIdService = async (id: string) =>
  handleApiCall(() => ApiService.delete(apiRoutes.taskById.replace(":id", id)));

export const editTaskService = async (id: string, taskData: FormData) =>
  handleApiCall(() =>
    ApiService.put(apiRoutes.taskById.replace(":id", id), taskData)
  );

export const learnerSubmitTaskService = async (taskId: any) =>
  handleApiCall(() => ApiService.post(apiRoutes.submitTask, { taskId }));

export const approveSubmitTaskService = async (
  submissionId: any,
  isApproved: boolean
) =>
  handleApiCall(() =>
    ApiService.put(
      apiRoutes.approveSubmitTask.replace(":submissionId", submissionId),
      { isApproved }
    )
  );
